import { useCallback, useState } from "react";

/**
 * Hook para padronizar gerenciamento de estado de campos de formulários.
 * @param  {...any} initialFields Nomes dos campos do formulário.
 */
export function useFormData(...initialFields) {
  const initialState = Object.fromEntries(
    initialFields.map(f => [f, { value: "", error: false, errorMsg: "" }])
  );

  const [formData, setFormData] = useState(initialState);

  const setFieldValue = useCallback((field, value) => {
    setFormData(prevState => ({
      ...prevState,
      [field]: { ...prevState[field], value },
    }));
  }, [setFormData]);

  const setFieldError = useCallback((field, errorMsg) => {
    setFormData(prevState => ({
      ...prevState,
      [field]: {
        ...prevState[field],
        error: !!errorMsg,
        errorMsg,
      },
    }));
  }, [setFormData]);

  return {
    /**
     * Objeto contendo o estado atual dos campos do formulário.
     */
    formData,
    /**
     * Função setState para atualizar o estado completo do formulário.
     */
    setFormData,
    /**
     * Função para atualizar o valor de um campo específico.
     * @param {string} field Nome do campo a ser atualizado.
     * @param {any} value Novo valor do campo.
     */
    setFieldValue,
    /**
     * Função para atualizar o estado de erro de um campo específico.
     * @param {string} field Nome do campo a ser atualizado.
     * @param {string} errorMsg Mensagem de erro. Se vazia, o erro é removido.
     */
    setFieldError,
  };
}
